import React, { useEffect, useState } from "react";
import UploadCategory from "../components/UploadCategory";
import SummaryApi from "../common";
import AdminCategoryCard from "../components/AdminCategoryCard";

const AllCategories = () => {
  const [openUploadCategory, setOpenUploadCategory] = useState(false);
  const [allCategories, setAllCategories] = useState([]);

  // Function to fetch all categories
  const fetchAllCategories = async () => {
    try {
      const response = await fetch(SummaryApi.getCategories.url);
      const dataResponse = await response.json();

      console.log("Fetched Categories:", dataResponse);

      setAllCategories(dataResponse?.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchAllCategories();
  }, []);

  return (
    <div>
      {/* Header */}
      <div className="bg-white py-2 px-4 flex justify-between items-center">
        <h2 className="font-bold text-lg">All Categories</h2>
        <button
          className="border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white transition-all py-1 px-3 rounded-full"
          onClick={() => setOpenUploadCategory(true)}
        >
          Add Category
        </button>
      </div>

      {/* Categories List */}
      <div className="flex items-center flex-wrap gap-5 py-4 h-[calc(100vh-190px)] overflow-y-auto">
        {allCategories.map((category, index) => (
          <AdminCategoryCard
            data={category}
            key={index + "_category"}
            fetchdata={fetchAllCategories}
          />
        ))}
      </div>

      {/* Upload Category Component */}
      {openUploadCategory && (
        <UploadCategory
          onClose={() => setOpenUploadCategory(false)}
          fetchData={fetchAllCategories}
        />
      )}
    </div>
  );
};

export default AllCategories;
